import { Box, Grid, Typography } from "@mui/material"
import { PropsFrecuency } from "./types"
import { DinamicForm } from "../../../../../../../components/dinamicForm"
import { DayOfWeeksSelector } from "../dayOfWeeksSelector"
import { useTranslation } from "react-i18next"
import { FrequencyEnum } from "../configCalendar/enums"
import { Constants } from "../../../../../../../utils/constants"
import { DateRangeWithoutDate } from "../../../../../../../components/dinamicForm/dateRangeWithoutDate/range"
import { useContextState } from "../../../../../../../hooks/theme"



const FrecuencyInput = ({ type, selectedsDays, mimTimeZone, refRange, setSelectedDays, input, inputSecond, data, errors, onChange, startDate, endDateName, endFromName, startDateName, startFromName, endDateNameButton, endFromNameButton, startDateNameButton, startFromNameButton }: PropsFrecuency) => {
    const { t } = useTranslation()
    const { colors } = useContextState()

    return (
        <Box>
            <Box sx={{ marginBottom: 2 }}>
                <Typography variant="text_grey">{type == FrequencyEnum.DAYLI ? t('schedule.assigned.everyDay') : t('schedule.assigned.businessDay')}</Typography>
                <DayOfWeeksSelector startDate={startDate} selectedDay={selectedsDays} setSelectedDay={setSelectedDays} multiple={true} />
                {errors.days && <Typography sx={{ color: colors.color28, fontSize: '12px', marginTop:'4px' }}>{errors.days}</Typography>}
            </Box>

            <Box sx={{ marginBottom: 3 }}>
                <Grid container spacing={1} sx={{ paddingLeft: '4px', paddingRight: '4px' }}>
                    <Grid item xs={type == FrequencyEnum.DAYLI ? 6 : 4}>
                        <DateRangeWithoutDate
                            mimTimeZone={mimTimeZone ?? Constants.defaultTimeZoneObject}
                            defaultErrors={{ from: errors[startDateName], to: errors[endDateName] }}
                            setDate={(payload) => {
                                onChange({
                                    target: {
                                        name: payload.target.name,
                                        value: payload.target.value,
                                    }
                                })
                            }}
                            from={data[startDateName]}
                            to={data[endDateName] ?? null}
                            ref={refRange}
                            buttonTitle={startDateNameButton}
                            isDateForm={false}
                            isFrom
                            title={t('general.tags.selectStartHour')}
                            fromName={startDateName}
                            toName={endDateName}
                            haveMinMax={false}
                            isRequired
                        />
                    </Grid>
                    {type !== FrequencyEnum.DAYLI && 
                    <Grid item xs={4}>
                        <DinamicForm input={Object.values(input)} legacyErrors values={data} onChange={onChange} errors={errors} />
                    </Grid>
                    }
                    <Grid item xs={type == FrequencyEnum.DAYLI ? 6 : 4}>
                        <DateRangeWithoutDate
                            mimTimeZone={mimTimeZone ?? Constants.defaultTimeZoneObject}
                            defaultErrors={{ from: errors[endDateName/* startDateName */], to: errors[startDateName/* endDateName */] }}
                            setDate={(payload) => {
                                onChange({
                                    target: {
                                        name: payload.target.name,
                                        value: payload.target.value,
                                    }
                                })
                            }}
                            from={data[endDateName/* startDateName */]}
                            to={data[startDateName/* endDateName */] ?? null}
                            ref={refRange}
                            buttonTitle={endDateNameButton}
                            isDateForm={false}
                            isFrom/* ={false} */
                            title={t('general.tags.selectEndHour')}
                            fromName={endDateName/* startDateName */}
                            toName={/* endDateName */ startDateName}
                            haveMinMax={false}
                            isRequired
                        />
                    </Grid>
                </Grid>


            </Box>

            <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('schedule.assigned.rangeOfTheSeries')}</Typography>

            <Box sx={{ marginTop: 2, marginBottom: 1 }}>
                <Grid container spacing={1} sx={{ paddingLeft: '4px', paddingRight: '4px' }}>
                    {type == FrequencyEnum.WEEKLY &&
                        <Grid item xs={4}>
                            <DinamicForm input={Object.values(inputSecond)} legacyErrors values={data} onChange={onChange} errors={errors} />
                        </Grid>
                    }
                    <Grid item xs={type == FrequencyEnum.WEEKLY ? 4 : 6}>
                        <DateRangeWithoutDate
                            mimTimeZone={mimTimeZone ?? Constants.defaultTimeZoneObject}
                            defaultErrors={{ from: errors[startFromName], to: errors[endFromName] }}
                            setDate={(payload) => {
                                onChange({
                                    target: {
                                        name: payload.target.name,
                                        value: payload.target.value,
                                    }
                                })
                            }}
                            from={data[startFromName]}
                            to={data[endFromName] ?? null}
                            ref={refRange}
                            buttonTitle={startFromNameButton}
                            isDateForm
                            isFrom
                            title={t('general.tags.selectStartDate')}
                            fromName={startFromName}
                            toName={endFromName}
                            haveMinMax
                            isRequired
                        />
                    </Grid>
                    <Grid item xs={type == FrequencyEnum.WEEKLY ? 4 : 6}>
                        <DateRangeWithoutDate
                            mimTimeZone={mimTimeZone ?? Constants.defaultTimeZoneObject}
                            defaultErrors={{ from: errors[startFromName], to: errors[endFromName] }}
                            setDate={(payload) => {
                                onChange({
                                    target: {
                                        name: payload.target.name,
                                        value: payload.target.value,
                                    }
                                })
                            }}
                            from={data[startFromName]}
                            to={data[endFromName] ?? null}
                            ref={refRange}
                            buttonTitle={endFromNameButton}
                            isDateForm
                            isFrom={false}
                            title={t('general.tags.selectEndDate')}
                            fromName={startFromName}
                            toName={endFromName}
                            haveMinMax
                            isRequired
                        />
                    </Grid>
                </Grid>

            </Box>
        </Box>
    )
}

export { FrecuencyInput }
